class SharedTimeoutId {
    private widgetTimeoutId: Record<string, NodeJS.Timeout> = {};

    clearWidgetTimeoutId(widgetId: string) {
        const timeoutId = this.widgetTimeoutId[widgetId];
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    }

    setNewWidgetTimeoutId(widgetId: string, timeoutId: NodeJS.Timeout) {
        this.widgetTimeoutId[widgetId] = timeoutId;
    }
}

const sharedTimeoutId = new SharedTimeoutId();

export { sharedTimeoutId };
